import Game from "./Game.js";
import AMatterSprite from "../../library/ExtendedObjects/AMatterSprite.js";
import gameData from "../../gameData.js";

export default class MoneyItem extends AMatterSprite
{
    /**
     * @param {Game} scene 
     */
    constructor(scene, x, y, moneyData)
    {
        super(scene, x, y, moneyData.sprite);
        scene.add.existing(this);

        this.moneyData = moneyData;
        this.scene = scene;
        this.isDragging = false;

        this.onUp = null;
        this.onMove = null;
        this.onDown = null;

        let bnds = this.scene.activeRegion;
        let img_bnds = this.body.bounds;
        let halfWidth = (img_bnds.max.x - img_bnds.min.x) * .5;
        let halfHeight = (img_bnds.max.y - img_bnds.min.y) * .5;

        this.minX = bnds.x + halfWidth;
        this.maxX = bnds.x + bnds.width - halfWidth;
        this.minY = bnds.y + halfHeight;
        this.maxY = bnds.y + bnds.height - halfHeight;

        this.boundaryForce = .1;

        this.on('pointerdown', (pointer, obj)=>{
            this.pointerDown();
        });
        this.on('pointerup', (pointer, obj)=>{
            this.pointerUp();
        });
        this.on('pointerout', (pointer, obj)=>{
            this.pointerUp();
        });
    }

    setScale(scale)
    {
        this.designatedScale = scale;
        return super.setScale(scale);
    }

    pointerDown()
    {
        this.scene.playSound("tweens");
        if (gameData.gameType == gameData.gameTypes.SORTING) this.setPosition(this.scene.input.x, this.scene.input.y);

        this.isDragging = true;
        this.body.velocity.x = this.body.velocity.y = 0;

        this.originalDepth = this.depth;
        this.setDepth(5);
        this.shadow.setDepth(5);

        this.scene.killTween([this.shadow, this]);

        this.draggingStarted();

        if (this.onDown) this.onDown(this);
    }

    pointerUp()
    {
        if(!this.isDragging) return;
        this.scene.killTween([this.shadow, this]);
        this.setScale(this.designatedScale).setDepth(this.originalDepth);
        this.isDragging = false;
        this.draggingStopped();
        this.shadow.setDepth(this.depth);

        if(this.onUp) this.onUp(this);
    }

    draggingStopped() {} //Overridden
    draggingStarted() {} //Overridden

    preUpdate(time, deltaTime)
    {
        this.angle = 0;

        if(!this.isDragging)
        {
            let bnds = this.scene.activeRegion;
            let img_bnds = this.body.bounds;
            let halfWidth = (img_bnds.max.x - img_bnds.min.x) * .5;
            let halfHeight = (img_bnds.max.y - img_bnds.min.y) * .5;

            this.minX = bnds.x + halfWidth;
            this.maxX = bnds.x + bnds.width - halfWidth;
            this.minY = bnds.y + halfHeight;
            this.maxY = bnds.y + bnds.height - halfHeight;

            if (this.x < this.minX) this.applyForce({ x: this.boundaryForce, y: 0 });
            if (this.x > this.maxX) this.applyForce({ x: -this.boundaryForce, y: 0 });
            if (this.y < this.minY) this.applyForce({ x: 0, y: this.boundaryForce });
            if (this.y > this.maxY) this.applyForce({ x: 0, y: -this.boundaryForce });
        } else if(this.onMove) this.onMove(this);

        if(this.inBounds(this.scene.menuRegion)) this.applyForce({ x: this.boundaryForce, y: this.boundaryForce });

        super.preUpdate(time, deltaTime)
    }

    inBounds(rectangle)
    {
        let img_bnds = this.body.bounds;
        let halfWidth = (img_bnds.max.x - img_bnds.min.x) * .5;
        let halfHeight = (img_bnds.max.y - img_bnds.min.y) * .5;
        let minX = rectangle.x - halfWidth;
        let maxX = (rectangle.x + rectangle.width) + halfWidth;
        let minY = rectangle.y - halfHeight;
        let maxY = (rectangle.y + rectangle.height) + halfHeight;

        if (this.x < minX || this.x > maxX || this.y < minY || this.y > maxY) return false;
        else return true;
    }
}